import store from '@Store';
import { getTrackingPathName } from '@AppRoutes/AppRoutesSelectors';

function addSourceKey(request) {
  // RXFE-3377
  if (!request.ignoreAllSpecificHeaders && !request?.headers?.sourceKey) {
    const sourceKey = getTrackingPathName(store.getState());
    request.headers = {
      sourceKey,
      ...request.headers,
    };
  }
  return request;
}

const SourceKeyInterceptor = {
  request: (config) => addSourceKey(config),
};

export default SourceKeyInterceptor;
